import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styles from 'assets/jss/material-dashboard-pro-react/components/emailModalStyle'
import { makeStyles } from '@material-ui/core/styles'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

const useStyles = makeStyles(styles)

export function UpdateStatusDialog(props) {
  const classes = useStyles()
  const { onClose, open, changeInvoiceStatus, title = 'Invoice', status, label } = props
  const [value, setValue] = useState('')

  const handleClose = () => {
    onClose()
  }

  const fieldChange = value => {
    setValue(value)
  }

  const submit = () => {
    changeInvoiceStatus(status, value)
    setValue('')
    handleClose()
  }

  return (
    <Dialog
      classes={{
        root: classes.center + ' ' + classes.modalRoot
      }}
      onClose={handleClose}
      open={open}
      fullWidth={true}
      maxWidth={'sm'}
    >
      <DialogTitle>{label + ' ' + title}</DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <TextField
          label="Comment"
          multiline
          rows="3"
          value={value}
          onChange={e => fieldChange(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button
          className={classes.colorPrimary}
          color="primary"
          disabled={!value}
          variant="outlined"
          onClick={() => submit()}
        >
          {label}
        </Button>
        <Button onClick={handleClose} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

UpdateStatusDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
}
